import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { noop } from 'lodash';

import { ConfigsService as GeneralConfigService } from '@sm360/widget-commons-core-services';
import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel';

const QUERY_NEW = gql`
    query fetchNewTotalCount($organizationUnitId: Int!, $vehicleCriteria: NewVehicleCriteria) {
        searchNewVehicles(first: 1, organizationUnitId: $organizationUnitId, newVehicleCriteria: $vehicleCriteria) {
            totalCount
        }
    }
`;

const QUERY_USED = gql`
    query fetchUsedTotalCount($organizationUnitId: Int!, $vehicleCriteria: VehicleCriteria) {
        searchVehicles(first: 1, organizationUnitId: $organizationUnitId, vehicleCriteria: $vehicleCriteria) {
            totalCount
        }
    }
`;

const isNew = (colanderGroup) => colanderGroup === COLANDER_GROUPS.NEW;

const getProps = (props) => {
    const { data, ownProps } = props;
    const { isLoading } = ownProps;
    let totalCount = 0;

    if (data && data.searchNewVehicles) {
        totalCount = data.searchNewVehicles.totalCount || 0;
    }
    if (data && data.searchVehicles) {
        totalCount = data.searchVehicles.totalCount || 0;
    }

    return {
        totalCount,
        isLoading,
    };
};

const getOptions = ({ vehicleCriteria, colanderGroup }) => {
    const criteria = vehicleCriteria || new VehicleCriteriaModel();

    const variables = {
        organizationUnitId: GeneralConfigService.getOrganizationUnitId(),
        vehicleCriteria: {
            ...criteria.mapToLimitedMandatoryPropertySetObject(),
            onlyBuiltVehicles: isNew(colanderGroup) ? criteria.onlyBuiltVehicles : false,
        },
    };

    return { variables };
};
// TODO: Get isLoading from graphQL and pass to child
const fetchNewTotalCount = graphql(QUERY_NEW, {
    alias: 'withTotalNewCount',
    options: getOptions,
    props: getProps,
    skip: (props) => !isNew(props.colanderGroup),
});

const fetchUsedTotalCount = graphql(QUERY_USED, {
    alias: 'withTotalUsedCount',
    options: getOptions,
    props: getProps,
    skip: (props) => isNew(props.colanderGroup),
});

function mapStateToProps(state) {
    return {
        colanderGroup: state.listingUsed.colanderGroup,
        vehicleCriteria: state.listingUsed.vehicleCriteria,
    };
}

const reduxContainer = connect(
    mapStateToProps,
    noop
);

export default compose(
    reduxContainer,
    fetchNewTotalCount,
    fetchUsedTotalCount
);



// WEBPACK FOOTER //
// ./client/src/components/ListingResults/ListingResultsContainer.js